import styled from 'styled-components';
import { media } from 'utils/rwd';

export const Container = styled.div``;

export const Label = styled.p`
  margin: 0;
  padding: 0 4px;
  color: ${({ $textColor }) => $textColor};
  font-size: 10px;
  text-transform: uppercase;

  ${media.lg`
    font-size: 12px;
  `}
  ${media.lg`
    font-size: 14px;
  `}
`;
